import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { ItemDiscountMeasureOption } from "@redotech/redo-return-core-common/return-flow/condition-enums";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  itemDiscountFromModel,
  validateItemDiscountCondition,
  type ItemDiscountState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const ITEM_DISCOUNT = (
  Details: React.ComponentType<ConditionTypeDetailsProps<ItemDiscountState>>,
): ConditionType<ItemDiscountState, Condition.ItemDiscount> => ({
  name: CONDITION_NAMES[Condition.ITEM_DISCOUNT],
  description(state) {
    return state.measureOption == ItemDiscountMeasureOption.PERCENT
      ? t("Item discounted by {{value}} % or greater", { value: state.value })
      : t("Item discounted by {{value}} in your currency or greater", {
          value: state.value,
        });
  },
  Details(props: ConditionTypeDetailsProps<ItemDiscountState>) {
    return React.createElement(Details, props);
  },
  empty: { measureOption: ItemDiscountMeasureOption.PERCENT, value: 10 },
  fromModel(model: Condition.ItemDiscount) {
    return itemDiscountFromModel(model);
  },
  toModel(state) {
    return {
      type: Condition.ITEM_DISCOUNT,
      measureOption: state.measureOption,
      value: state.value,
    };
  },
  valid(state) {
    return validateItemDiscountCondition(state).valid;
  },
});
